import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { postMerchantRevokeTokenAPI } from 'src/serverApi/merchants';
import useWithAuthorities from 'src/utils/useWithAuthorities';
import permissions from 'src/constants/permissions';
import Button from 'src/components/Button';
import LinkButton from 'src/components/LinkButton';
import Modal from 'src/components/Modal';
import MerchantInfo from './MerchantInfo';
import { toast } from 'react-toastify';
import styles from './styles.module.scss';

type Props = {
  merchant: any;
  reloadMerchants: () => Promise<any>;
};

const RevokeTokenButton: React.FC<Props> = ({ merchant, reloadMerchants }) => {
  const { organizationUeid = '', bankUeid = '' } = useParams();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const withAuthorities = useWithAuthorities([permissions.dataManagement]);

  const handleRevokeTokenButtonClick = () => {
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  const handleRevokeTokenAccept = async () => {
    try {
      setIsLoading(true);
      await withAuthorities(async () => {
        await postMerchantRevokeTokenAPI(organizationUeid, bankUeid, merchant?.ueid);
        setIsDialogOpen(false);
        reloadMerchants();
      });
    } catch (error) {
      toast.error('Произошла ошибка при попытке отозвать токен');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <LinkButton onClick={handleRevokeTokenButtonClick}>Отозвать</LinkButton>
      <Modal
        isOpen={isDialogOpen}
        onClose={handleCloseDialog}
        title="Вы действительно хотите отозвать токен?"
        content={
          <MerchantInfo
            merchant={merchant}
            tokenEmissionTimestamp={merchant?.tokenEmissionTimestamp}
          />
        }
        footer={
          <>
            <Button disabled={isLoading} onClick={handleCloseDialog} className={styles['modal-button']}>
              Отмена
            </Button>
            <Button
              variant="outlined"
              disabled={isLoading}
              onClick={handleRevokeTokenAccept}
              className={styles['modal-button']}
            >
              Отозвать
            </Button>
          </>
        }
      />
    </>
  );
};

export default RevokeTokenButton;
